(() => {
 const html=document.documentElement;
 let footerVisible=false,scheduled=false;
 const sync=()=>{
  scheduled=false;
  const openMenu=!!document.querySelector('.desktop-nav .nav-panel:not([hidden]),dialog[open]')||document.body.classList.contains('boost-pfs-filter-tree-open-body');
  const footerNow=document.querySelector('footer.footer');
  const footerBox=footerNow?.getBoundingClientRect();
  footerVisible=!!(footerBox&&footerBox.top<innerHeight+120&&footerBox.bottom>0);
  const hide=openMenu||footerVisible||(innerWidth<=768&&scrollY>50);
  if(html.classList.contains('gsr-hide-trustbadge')!==hide)html.classList.toggle('gsr-hide-trustbadge',hide);
  const header=document.querySelector('.site-header');
  if(header)html.style.setProperty('--gsr-header-offset',Math.ceil(header.getBoundingClientRect().height+20)+'px');
 };
 const queue=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(sync)}};
 const footer=document.querySelector('footer.footer');
 if(footer)new IntersectionObserver(es=>{footerVisible=es[0].isIntersecting;queue()},{rootMargin:'0px 0px 120px 0px'}).observe(footer);
 const header=document.querySelector('.site-header');
 if(header)new MutationObserver(queue).observe(header,{attributes:true,subtree:true,attributeFilter:['hidden','aria-expanded']});
 document.querySelectorAll('dialog').forEach(d=>new MutationObserver(queue).observe(d,{attributes:true,attributeFilter:['open']}));
 new MutationObserver(queue).observe(document.body,{attributes:true,attributeFilter:['class']});
 addEventListener('scroll',queue,{passive:true});addEventListener('resize',queue);
 document.addEventListener('DOMContentLoaded',queue);addEventListener('load',queue);
 new MutationObserver(queue).observe(document.body,{childList:true});
 sync();
 const slot=document.querySelector('.gsr-wishlist-slot'),pdp=document.querySelector('.pdp-info');
 if(slot&&pdp){
  const place=()=>{
   const node=document.querySelector('#wishlisthero-product-page-button-container');
   if(node&&!slot.contains(node))slot.appendChild(node);
   slot.querySelectorAll('button').forEach(b=>b.type='button');
  };
  place();new MutationObserver(place).observe(pdp,{childList:true,subtree:true});
 }
 // Birthstone hashes stay valid when Shopify generates a new template ID.
 const alignHash=()=>{
  if(!document.querySelector('.gs-birthstones')||!location.hash)return;
  let target=document.getElementById(decodeURIComponent(location.hash.slice(1)));
  if(!target){const m=location.hash.match(/(?:birthstones-|geburtsstein-)(januar|februar|maerz|april|mai|juni|juli|august|september|oktober|november|dezember)$/);if(m)target=document.getElementById('geburtsstein-'+m[1]);}
  if(target){const month=target.closest('.month-section')||target;const heading=month.querySelector('.month-heading')||month;const offset=parseFloat(getComputedStyle(html).getPropertyValue('--gsr-header-offset'))||150;scrollTo({top:heading.getBoundingClientRect().top+scrollY-offset,behavior:'instant'});}
 };
 addEventListener('hashchange',()=>requestAnimationFrame(alignHash));addEventListener('load',alignHash);
})();

// Keep the existing Related Collections Navigator widget, but place it above filters.
(()=>{
 const slot=document.querySelector('.gsr-special-collections-slot');
 if(!slot)return;
 let queued=false;
 const move=()=>{
  queued=false;
  document.querySelectorAll('.surfMainDiv').forEach(row=>{
   if(slot.contains(row)||!row.querySelector('a[href*="/collections/"]'))return;
   const section=row.closest('.shopify-section');
   if(!section||section.contains(slot))return;
   slot.appendChild(section);
   row.querySelectorAll('h3').forEach(h=>{if(!h.textContent.trim())h.hidden=true});
   requestAnimationFrame(()=>row.querySelectorAll('.swiper').forEach(el=>{if(typeof el.swiper?.update==='function')el.swiper.update()}));
  });
 };
 const queue=()=>{if(!queued){queued=true;requestAnimationFrame(move)}};
 move();new MutationObserver(queue).observe(document.querySelector('#main-content'),{childList:true,subtree:true});
 document.addEventListener('shopify:section:load',queue);
})();

// Explicit navigation for the five reported legal links only.
// Modifier/new-tab clicks, CookieFirst and all other application actions remain native.
(()=>{
 const paths=new Set(['/policies/terms-of-service','/policies/legal-notice','/policies/privacy-policy','/policies/refund-policy','/pages/gewaehrleistung']);
 window.addEventListener('click',e=>{
  if(e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  const a=e.target instanceof Element?e.target.closest('.footer-legal a[href]'):null;
  if(!a||a.hasAttribute('download')||(a.target&&a.target!=='_self'))return;
  if(a.hasAttribute('data-cookie-settings')||a.getAttribute('href')==='#cookie-einstellungen')return;
  let u;try{u=new URL(a.href,location.href)}catch{return}
  if(u.origin!==location.origin||!paths.has(u.pathname.replace(/\/$/,'')))return;
  e.preventDefault();e.stopImmediatePropagation();location.assign(u.href);
 },true);
})();
// Match the native sort field width to its actual selected label, not the toolbar.
(()=>{
 const bar=document.querySelector('.gsr-boost-toolbar');if(!bar)return;
 const ctx=document.createElement('canvas').getContext('2d');
 let queued=false;
 const fit=()=>{
  queued=false;
  bar.querySelectorAll('.gsr-sort-label select').forEach(el=>{
   if(el.selectedIndex<0&&el.options.length){
    const current=window.Globals?.queryParams?.sort||window.Globals?.defaultSorting;
    if(current&&!Array.from(el.options).some(o=>o.value===current))el.add(new Option('Empfohlen',current,true,true));
    else if(current)el.value=current;
    if(el.selectedIndex<0)el.selectedIndex=0;
   }
   const s=getComputedStyle(el),label=el.selectedOptions[0]?.textContent||'Empfohlen';
   if(ctx)ctx.font=s.fontWeight+' '+s.fontSize+' '+s.fontFamily;
   const spacing=parseFloat(s.letterSpacing)||0;
   const width=Math.min(220,Math.max(80,Math.ceil(ctx?ctx.measureText(label).width:label.length*8)+Math.max(0,label.length-1)*spacing+48));
   el.style.width=width+'px';
  });
 };
 const queue=()=>{if(!queued){queued=true;requestAnimationFrame(fit)}};
 new MutationObserver(queue).observe(bar,{childList:true,subtree:true});
 bar.addEventListener('change',queue);
 document.addEventListener('gsr:products-rendered',queue);
 addEventListener('resize',queue);document.fonts?.ready.then(queue);queue();
})();
// Reserve the actual header and thumbnail height for the sticky product image.
(()=>{
 const gallery=document.querySelector('[data-gsr-product]>.pdp-gallery');if(!gallery)return;
 const header=document.querySelector('.site-header'),thumbs=gallery.querySelector('.gallery-thumbs');
 const fit=()=>{
  if(header)document.documentElement.style.setProperty('--gsr-header-offset',Math.ceil(header.getBoundingClientRect().height+20)+'px');
  const extra=thumbs?thumbs.getBoundingClientRect().height+parseFloat(getComputedStyle(thumbs).marginTop||0)+20:20;
  gallery.style.setProperty('--gsr-gallery-extra',Math.ceil(extra)+'px');
 };
 const observer=new ResizeObserver(fit);
 if(header)observer.observe(header);if(thumbs)observer.observe(thumbs);
 addEventListener('resize',fit);document.fonts?.ready.then(fit);fit();
})();

// Mobile filter retains the old rose drawer, with an accessible close control.
(()=>{
 const controls=document.querySelector('.gsr-boost-controls');if(!controls)return;
 const enhance=()=>{
  const tree=controls.querySelector('.boost-pfs-filter-tree-v');if(!tree)return;
  if(!tree.querySelector('.gsr-filter-close')){
   const button=document.createElement('button');button.type='button';button.className='gsr-filter-close';button.setAttribute('aria-label','Filter schließen');button.textContent='×';
   button.addEventListener('click',()=>tree.querySelector('.boost-pfs-filter-close')?.click());tree.appendChild(button);
  }
 };
 new MutationObserver(enhance).observe(controls,{childList:true,subtree:true});enhance();
})();
// Three-level mobile drill-down, matching the previous shop's navigation model.
(()=>{
 const menu=document.querySelector('#mobile-menu');if(!menu)return;
 let current='root';
 const show=(id,focus=true)=>{
  const panels=[...menu.querySelectorAll('[data-menu-panel]')];
  const selected=panels.find(p=>p.dataset.menuPanel===id);if(!selected)return;
  panels.forEach(p=>p.hidden=p!==selected);current=id;menu.scrollTop=0;
  if(focus)selected.querySelector('button,a')?.focus({preventScroll:true});
 };
 menu.addEventListener('click',e=>{const b=e.target.closest('[data-menu-next]');if(b){e.preventDefault();show(b.dataset.menuNext)}});
 menu.addEventListener('close',()=>show('root',false));
 menu.addEventListener('cancel',e=>{if(current!=='root'){e.preventDefault();const active=menu.querySelector('[data-menu-panel="'+current+'"]');show(active?.dataset.menuParent||'root')}});
})();
// Full-size square image; oversized galleries travel naturally before sticking.
(()=>{
 const g=document.querySelector('[data-gsr-product]>.pdp-gallery');if(!g)return;
 const head=document.querySelector('.site-header');
 let previousY=scrollY,stickyTop=null,queued=false;
 const fit=()=>{
  queued=false;
  if(!matchMedia('(min-width:761px) and (min-height:560px)').matches){g.style.removeProperty('--gsr-gallery-sticky-top');previousY=scrollY;stickyTop=null;return}
  const high=Math.ceil((head?.getBoundingClientRect().height||140)+20);
  const low=Math.min(high,innerHeight-g.getBoundingClientRect().height-20);
  const delta=scrollY-previousY;
  stickyTop=Math.max(low,Math.min(high,stickyTop===null?high-scrollY:stickyTop-delta));
  g.style.setProperty('--gsr-gallery-sticky-top',Math.round(stickyTop)+'px');
  previousY=scrollY;
 };
 const queue=()=>{if(!queued){queued=true;requestAnimationFrame(fit)}};
 const observer=new ResizeObserver(queue);observer.observe(g);if(head)observer.observe(head);
 addEventListener('scroll',queue,{passive:true});addEventListener('resize',queue);queue();
})();
// Keep the app's category destinations, without autoplay or clipped carousel cards.
(()=>{
 const slot=document.querySelector('.gsr-special-collections-slot');if(!slot)return;
 let scheduled=false;
 const update=()=>{
  scheduled=false;
  const source=slot.querySelector('.surfMainDiv');if(!source)return;
  source.querySelectorAll('.swiper').forEach(e=>{if(e.swiper?.autoplay?.running)e.swiper.autoplay.stop()});
  const links=[...source.querySelectorAll('a[href*="/collections/"]')].map((a,i)=>({
   href:a.href,label:a.textContent.trim().replace(/\s+/g,' '),
   index:Number(a.closest('[data-swiper-slide-index]')?.getAttribute('data-swiper-slide-index')??i)
  })).filter(x=>x.label).sort((a,b)=>a.index-b.index);
  const seen=new Set(),unique=links.filter(x=>{if(seen.has(x.href))return false;seen.add(x.href);return true});
  if(!unique.length)return;
  const signature=JSON.stringify(unique);
  let nav=slot.querySelector('.gsr-related-links');
  if(nav?.dataset.signature===signature)return;
  if(!nav){nav=document.createElement('nav');nav.className='gsr-related-links';nav.setAttribute('aria-label','Weitere Schmuckkollektionen');slot.prepend(nav)}
  nav.dataset.signature=signature;nav.replaceChildren();
  unique.forEach(x=>{const a=document.createElement('a');a.href=x.href;a.textContent=x.label;if(new URL(x.href).pathname===location.pathname)a.setAttribute('aria-current','page');nav.appendChild(a)});
  slot.classList.add('gsr-related-ready');
 };
 const queue=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update)}};
 new MutationObserver(queue).observe(slot,{childList:true,subtree:true});update();
})();

// Full-viewport dimming and an explicit completion step for mobile filters.
(()=>{
 const controls=document.querySelector('.gsr-boost-controls');if(!controls)return;
 const mobile=matchMedia('(max-width:760px)');
 const backdrop=document.createElement('button');
 backdrop.type='button';backdrop.className='gsr-filter-backdrop';backdrop.hidden=true;
 backdrop.tabIndex=-1;backdrop.setAttribute('aria-label','Filter schließen');
 document.body.appendChild(backdrop);
 let tree=null,observer=null,wasOpen=false,originalMeta=[],temporaryMeta=null;
 const close=()=>tree?.querySelector('.boost-pfs-filter-close')?.click();
 const setChrome=open=>{
  if(open){
   originalMeta=[...document.querySelectorAll('meta[name="theme-color"]')].map(node=>({node,content:node.getAttribute('content')}));
   if(originalMeta.length)originalMeta.forEach(({node})=>node.setAttribute('content','#fbf2f5'));
   else{temporaryMeta=document.createElement('meta');temporaryMeta.name='theme-color';temporaryMeta.content='#fbf2f5';document.head.appendChild(temporaryMeta)}
  }else{
   originalMeta.forEach(({node,content})=>content===null?node.removeAttribute('content'):node.setAttribute('content',content));
   originalMeta=[];temporaryMeta?.remove();temporaryMeta=null;
  }
 };
 const sync=()=>{
  const open=mobile.matches&&!!tree?.classList.contains('boost-pfs-filter-tree-mobile-open');
  backdrop.hidden=!open;document.documentElement.classList.toggle('gsr-filter-is-open',open);
  if(open)document.documentElement.style.setProperty('--gsr-filter-viewport-height',Math.round(window.visualViewport?.height||innerHeight)+'px');
  if(open!==wasOpen){setChrome(open);wasOpen=open}
 };
 const bind=()=>{
  const next=controls.querySelector('.boost-pfs-filter-tree-v');if(next===tree)return;
  observer?.disconnect();tree=next;
  if(tree){observer=new MutationObserver(sync);observer.observe(tree,{attributes:true,attributeFilter:['class']})}
  sync();
 };
 backdrop.addEventListener('click',close);
 controls.addEventListener('click',event=>{
  const apply=event.target.closest('.boost-pfs-filter-apply-button');
  if(!mobile.matches||!apply||!tree?.contains(apply))return;
  event.preventDefault();
  // Keep selections and return to the full filter overview. Only the separate
  // results button completes the interaction and closes the drawer.
  requestAnimationFrame(()=>{
   const back=tree?.querySelector('.boost-pfs-filter-back-btn');
   if(back&&getComputedStyle(back).display!=='none')back.click();
   const options=tree?.querySelector('.boost-pfs-filter-options-wrapper');
   if(options)options.scrollTop=0;
  });
 });
 document.addEventListener('keydown',event=>{if(wasOpen&&event.key==='Escape'){event.preventDefault();close()}});
 new MutationObserver(bind).observe(controls,{childList:true,subtree:true});
 mobile.addEventListener('change',sync);window.visualViewport?.addEventListener('resize',sync);
 addEventListener('resize',sync);bind();
})();

// Swipe the main product image on mobile; keep taps, vertical scroll and pinch.
(()=>{
 document.addEventListener('keydown',event=>{if(event.key==='Tab')document.documentElement.classList.add('gsr-keyboard-input')});
 document.addEventListener('pointerdown',()=>document.documentElement.classList.remove('gsr-keyboard-input'),{passive:true});
 const product=document.querySelector('[data-gsr-product]'),main=product?.querySelector('.product-main-image');
 if(!main)return;
 let start=null,horizontal=false,ignoreClickUntil=0;
 const thumbs=()=>[...product.querySelectorAll('.gallery-thumb')];
 const cancel=()=>{start=null;horizontal=false};
 main.addEventListener('touchstart',event=>{
  if(!matchMedia('(max-width:760px)').matches||event.touches.length!==1||thumbs().length<2){cancel();return}
  start={x:event.touches[0].clientX,y:event.touches[0].clientY};horizontal=false;
 },{passive:true});
 main.addEventListener('touchmove',event=>{
  if(!start||event.touches.length!==1){cancel();return}
  const dx=event.touches[0].clientX-start.x,dy=event.touches[0].clientY-start.y;
  if(!horizontal&&Math.abs(dy)>12&&Math.abs(dy)>Math.abs(dx)){cancel();return}
  if(Math.abs(dx)>12&&Math.abs(dx)>Math.abs(dy)*1.3)horizontal=true;
  if(horizontal&&event.cancelable)event.preventDefault();
 },{passive:false});
 main.addEventListener('touchend',event=>{
  if(!start||!event.changedTouches.length){cancel();return}
  const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;
  if(Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.3){
   const list=thumbs(),current=Math.max(0,list.findIndex(e=>e.classList.contains('is-selected')));
   const next=(current+(dx<0?1:-1)+list.length)%list.length;
   ignoreClickUntil=performance.now()+500;list[next].click();
   const rail=product.querySelector('.gallery-thumbs');
   if(rail&&rail.scrollWidth>rail.clientWidth)rail.scrollTo({left:list[next].offsetLeft-rail.offsetLeft-12,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  }
  cancel();
 },{passive:true});
 main.addEventListener('touchcancel',cancel,{passive:true});
 main.addEventListener('click',event=>{if(performance.now()<ignoreClickUntil){event.preventDefault();event.stopImmediatePropagation()}},{capture:true});
})();

// The enlarged image must support the same navigation without closing its dialog.
(()=>{
 const product=document.querySelector('[data-gsr-product]');if(!product)return;
 const bind=()=>{
  const dialog=document.querySelector('#gsr-zoom');if(!dialog||dialog.dataset.gsrSwipeReady)return;
  dialog.dataset.gsrSwipeReady='true';
  let start=null,horizontal=false,ignoreClickUntil=0;
  const cancel=()=>{start=null;horizontal=false};
  const advance=direction=>{
   const thumbs=[...product.querySelectorAll('.gallery-thumb')];if(thumbs.length<2)return;
   const current=Math.max(0,thumbs.findIndex(t=>t.classList.contains('is-selected')));
   const next=(current+direction+thumbs.length)%thumbs.length;
   thumbs[next].click();
   const zoomImage=dialog.querySelector('img'),main=product.querySelector('.product-main-image>img');
   if(zoomImage){zoomImage.src=thumbs[next].dataset.gsrImage||main?.src;zoomImage.alt=(main?.alt||'Produktbild')+' · Bild '+(next+1)+' von '+thumbs.length}
  };
  dialog.addEventListener('touchstart',e=>{
   if(!dialog.open||!matchMedia('(max-width:760px)').matches||e.touches.length!==1||e.target.closest('button')){cancel();return}
   start={x:e.touches[0].clientX,y:e.touches[0].clientY};horizontal=false;
  },{passive:true});
  dialog.addEventListener('touchmove',e=>{
   if(!start||e.touches.length!==1){cancel();return}
   const dx=e.touches[0].clientX-start.x,dy=e.touches[0].clientY-start.y;
   if(!horizontal&&Math.abs(dy)>12&&Math.abs(dy)>Math.abs(dx)){cancel();return}
   if(Math.abs(dx)>12&&Math.abs(dx)>Math.abs(dy)*1.3)horizontal=true;
   if(horizontal&&e.cancelable)e.preventDefault();
  },{passive:false});
  dialog.addEventListener('touchend',e=>{
   if(!start||!e.changedTouches.length){cancel();return}
   const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;
   if(Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.3){ignoreClickUntil=performance.now()+500;advance(dx<0?1:-1)}
   cancel();
  },{passive:true});
  dialog.addEventListener('touchcancel',cancel,{passive:true});
  dialog.addEventListener('close',cancel);
  dialog.addEventListener('click',e=>{if(performance.now()<ignoreClickUntil&&!e.target.closest('button')){e.preventDefault();e.stopImmediatePropagation()}},{capture:true});
  dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();advance(e.key==='ArrowRight'?1:-1)}});
 };
 new MutationObserver(bind).observe(document.body,{childList:true,subtree:true});bind();
})();

// Put reset in a full-width, unobstructed position rather than beside the title.
(()=>{
 const controls=document.querySelector('.gsr-boost-controls');if(!controls)return;
 let queued=false;
 const update=()=>{
  queued=false;
  controls.querySelectorAll('.boost-pfs-filter-refine-by>.boost-pfs-filter-option-title .boost-pfs-filter-option-title-heading>span,.boost-pfs-filter-refine-by>span').forEach(e=>{
   if(e.textContent.trim().toLowerCase()==='filter'&&e.textContent!=='FILTER')e.textContent='FILTER';
  });
  const tree=controls.querySelector('.boost-pfs-filter-tree-v');
  const footer=tree?.querySelector('.boost-pfs-filter-mobile-footer');if(!footer)return;
  let button=footer.querySelector('.gsr-filter-reset-all');
  if(!button){
   button=document.createElement('button');button.type='button';button.className='gsr-filter-reset-all';button.textContent='ALLE FILTER ZURÜCKSETZEN';
   button.addEventListener('click',()=>{
    const native=tree.querySelector('.boost-pfs-filter-mobile-toolbar .boost-pfs-filter-clear-all')||tree.querySelector('.boost-pfs-filter-clear-all');
    if(native){native.click();const back=tree.querySelector('.boost-pfs-filter-back-btn');if(back&&getComputedStyle(back).display!=='none')back.click()}
   });
   footer.prepend(button);
  }
  const active=Object.keys(window.Globals?.queryParams||{}).some(key=>key.startsWith('pf_'));
  if(button.hidden===active)button.hidden=!active;
 };
 const queue=()=>{if(!queued){queued=true;requestAnimationFrame(update)}};
 new MutationObserver(queue).observe(controls,{childList:true,subtree:true});
 addEventListener('popstate',queue);update();
})();

// Keep product images inline on every viewport, while retaining mobile touch swipes.
(()=>{
 const main=document.querySelector('[data-gsr-product] .product-main-image');if(!main)return;
 main.disabled=false;
 main.removeAttribute('data-image-zoom');main.setAttribute('tabindex','-1');main.setAttribute('role','img');
 main.setAttribute('aria-label',main.querySelector('img')?.alt||'Produktbild');
 document.querySelector('#gsr-zoom[open]')?.close();
 main.addEventListener('click',event=>{event.preventDefault();event.stopImmediatePropagation()},{capture:true});
})();

// Open the existing consent manager from every footer, including policy pages.
(()=>{
 let pending=false,requestedLink=null,timeout=null;
 const clearBusy=()=>{requestedLink?.removeAttribute('aria-busy');clearTimeout(timeout)};
 const open=()=>{
  if(!pending||typeof window.CookieFirst?.openPanel!=='function')return false;
  try{window.CookieFirst.openPanel('settings');pending=false;clearBusy();return true}
  catch(error){console.warn('Cookie settings could not open',error);return false}
 };
 const showFailure=()=>{
  if(!pending)return;
  pending=false;clearBusy();
  let status=document.querySelector('#gsr-cookie-status');
  if(!status){status=document.createElement('p');status.id='gsr-cookie-status';status.setAttribute('role','status');requestedLink?.closest('nav')?.after(status)}
  status.textContent='Die Cookie-Einstellungen konnten nicht geladen werden. Bitte lade die Seite neu oder prüfe, ob ein Inhaltsblocker CookieFirst blockiert.';
 };
 window.addEventListener('click',event=>{
  if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const link=event.target instanceof Element?event.target.closest('a[data-cookie-settings],a[href="#cookie-einstellungen"]'):null;
  if(!link)return;
  event.preventDefault();event.stopImmediatePropagation();
  document.querySelector('#gsr-cookie-status')?.remove();
  requestedLink=link;pending=true;link.setAttribute('aria-busy','true');
  if(!open()){clearTimeout(timeout);timeout=setTimeout(showFailure,10000)}
 },true);
 window.addEventListener('cf_init',open);
 window.addEventListener('load',open);
})();
